import { useState } from 'react';

const faqs = [
  {
    question: "Intervenez-vous vraiment 24h/24 et 7j/7 à Genève ?",
    answer: "Oui, CasaReNovaPlus assure un service de dépannage d'urgence 24h/24 et 7j/7 dans tout le canton de Fribourg et en Suisse romande. Que ce soit en pleine nuit, le week-end ou les jours fériés, nos techniciens sont disponibles. Appelez le 079 761 62 82 pour une intervention immédiate."
  },
  {
    question: "Quel est le délai d'intervention pour une urgence à Genève ?",
    answer: "Pour les urgences à Genève, notre délai d'intervention moyen est de 30 à 90 minutes selon votre localisation et l'heure de l'appel. Nous intervenons en priorité pour les pannes électriques, les fuites d'eau, les pannes de chauffage en hiver et les problèmes de ventilation critiques."
  },
  {
    question: "Quels types de pannes prenez-vous en charge en urgence ?",
    answer: "CasaReNovaPlus intervient en urgence pour : pannes électriques (disjoncteur, court-circuit, panne de courant), fuites d'eau et dégâts des eaux, pannes de chauffage (chaudière, pompe à chaleur), problèmes de ventilation et climatisation, et tout autre problème technique CVSE nécessitant une intervention rapide."
  },
  {
    question: "Proposez-vous des contrats de maintenance préventive à Genève ?",
    answer: "Oui, CasaReNovaPlus propose des contrats de maintenance préventive sur mesure pour particuliers, entreprises et gestionnaires d'immeubles à Neuenegg. Ces contrats incluent des visites régulières programmées, des contrôles complets de vos installations, le remplacement préventif des pièces d'usure et un accès prioritaire à notre service d'urgence."
  },
  {
    question: "Combien coûte une intervention d'urgence à Genève ?",
    answer: "Le coût d'une intervention d'urgence dépend de la nature de la panne, de l'heure d'intervention et du temps de travail nécessaire. CasaReNovaPlus applique une transparence totale : le technicien établit un devis sur place avant de commencer les travaux. Pas de mauvaise surprise. Contactez-nous au 079 761 62 82 pour plus d'informations."
  },
  {
    question: "Intervenez-vous pour la maintenance d'immeubles et de copropriétés à Genève ?",
    answer: "Oui, CasaReNovaPlus assure la maintenance complète d'immeubles résidentiels et commerciaux à Neuenegg. Nous travaillons avec les régies immobilières, les syndics de copropriété et les gestionnaires d'actifs. Nos prestations incluent la maintenance des installations électriques, sanitaires, de chauffage et de ventilation des parties communes et des appartements."
  },
  {
    question: "Pouvez-vous effectuer un diagnostic complet de mes installations à Genève ?",
    answer: "Absolument. CasaReNovaPlus propose des diagnostics complets de vos installations CVSE (Chauffage, Ventilation, Sanitaire, Électricité) à Genève. Ce diagnostic permet d'identifier les problèmes existants, les risques potentiels et les travaux de mise aux normes nécessaires. Un rapport détaillé vous est remis avec nos recommandations."
  },
  {
    question: "Dans quelles zones de Genève intervenez-vous pour la maintenance ?",
    answer: "CasaReNovaPlus intervient pour la maintenance dans tout le canton de Fribourg : Neuenegg, Fribourg, Bulle, Romont, Murten, Villars-sur-Glâne et toutes les autres communes fribourgeoises. Nous couvrons également Berne, Vaud, Valais et Neuchâtel pour les contrats de maintenance."
  }
];

export default function MaintenanceFAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);

  return (
    <section id="faq-maintenance" className="py-24 bg-gray-950">
      <div className="mx-auto max-w-4xl px-6 lg:px-8">

        {/* Header */}
        <div className="text-center mb-14">
          <div className="inline-flex items-center gap-2 bg-red-500/10 border border-red-500/25 rounded-full px-4 py-1.5 mb-5">
            <i className="ri-question-answer-line text-red-400 text-sm"></i>
            <span className="text-xs font-bold tracking-widest uppercase text-red-400">Questions fréquentes</span>
          </div>
          <h2 className="text-3xl font-bold text-white sm:text-4xl mb-4">
            Tout savoir sur notre service<br />
            <span className="text-amber-400">de dépannage à Genève</span>
          </h2>
          <p className="text-gray-400 text-sm max-w-xl mx-auto leading-relaxed">
            Les questions les plus posées sur notre service d'urgence et de maintenance à Genève.
          </p>
        </div>

        {/* Urgence banner */}
        <div className="flex items-center gap-4 bg-red-500/10 border border-red-500/30 rounded-xl px-6 py-4 mb-8">
          <div className="w-10 h-10 flex items-center justify-center bg-red-500 rounded-lg shrink-0">
            <i className="ri-alarm-warning-line text-white text-lg"></i>
          </div>
          <div className="flex-1">
            <p className="text-white text-sm font-semibold">Urgence en ce moment ?</p>
            <p className="text-gray-400 text-xs">Filipe: <strong className="text-white">+41 76 480 31 88</strong> &nbsp;|&nbsp; Francisco: <strong className="text-white">+41 76 565 42 03</strong> — 24h/24 et 7j/7</p>
          </div>
          <a
            href="tel:+41764803188"
            className="shrink-0 inline-flex items-center gap-2 rounded-lg bg-red-500 px-5 py-2.5 text-sm font-semibold text-white hover:bg-red-600 transition-all whitespace-nowrap cursor-pointer"
          >
            <i className="ri-phone-line"></i>
            Appeler
          </a>
        </div>

        {/* FAQ accordéon */}
        <div className="space-y-3">
          {faqs.map((faq, index) => (
            <div
              key={index}
              className={`rounded-xl border transition-all duration-200 overflow-hidden ${
                openIndex === index
                  ? 'border-amber-500/40 bg-amber-500/5'
                  : 'border-white/8 bg-white/3 hover:border-white/15'
              }`}
            >
              <button
                onClick={() => setOpenIndex(openIndex === index ? null : index)}
                className="w-full flex items-center justify-between gap-4 px-6 py-5 text-left cursor-pointer"
              >
                <div className="flex items-start gap-3">
                  <div className={`w-6 h-6 flex items-center justify-center rounded-full shrink-0 mt-0.5 text-xs font-bold transition-colors ${
                    openIndex === index ? 'bg-amber-500 text-white' : 'bg-white/10 text-gray-400'
                  }`}>
                    {index + 1}
                  </div>
                  <span className={`text-sm font-semibold leading-snug transition-colors ${
                    openIndex === index ? 'text-amber-400' : 'text-white'
                  }`}>
                    {faq.question}
                  </span>
                </div>
                <i className={`ri-${openIndex === index ? 'subtract' : 'add'}-line text-lg shrink-0 transition-colors ${
                  openIndex === index ? 'text-amber-400' : 'text-gray-500'
                }`}></i>
              </button>

              {openIndex === index && (
                <div className="px-6 pb-5 pl-[3.75rem]">
                  <p className="text-gray-300 text-sm leading-relaxed">{faq.answer}</p>
                </div>
              )}
            </div>
          ))}
        </div>

        {/* CTA bas */}
        <div className="mt-12 flex flex-col sm:flex-row items-center justify-between gap-6 bg-white/3 border border-white/8 rounded-2xl px-8 py-6">
          <div>
            <p className="text-white font-semibold text-sm mb-1">Besoin d'un contrat de maintenance ?</p>
            <p className="text-gray-400 text-xs">Devis gratuit sous 24h pour particuliers et entreprises.</p>
          </div>
          <a
            href="#contact"
            className="shrink-0 inline-flex items-center gap-2 rounded-lg bg-amber-500 px-6 py-3 text-sm font-semibold text-white hover:bg-amber-600 transition-all whitespace-nowrap cursor-pointer"
          >
            <i className="ri-file-list-3-line"></i>
            Demander un devis
          </a>
        </div>
      </div>
    </section>
  );
}
